export class DocTypesRequest {
  idf: number;
  dc: number[];

  constructor(obj: any) {
    this.idf = obj && obj.idf || null;
    this.dc = obj && obj.dc || null;
  }
}
